<template>
  <div :class="classes('speech-button-container')" @click="$emit('click')">
    <span :class="classes('label')">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'VvSpeechButton',
  props: {
    label: String,
    active: Boolean
  },
  methods: {
    classes(classes = '') {
      return this.active ? `${classes} active` : classes
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.speech-button-container {
  width: 100%;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  border-radius: 4px;
  display: inline-block;
  padding: 8px 0;
  text-align: center;
  margin-bottom: 15px;
  background: #fff;
  transition: 200ms;

  &:not(.active):hover {
    background: $primary;

    .label {
      color: white;
      opacity: 0.8;
    }
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    background: #fff;
    height: 20px;
    width: 20px;
    transform: rotate(45deg);
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    bottom: -5px;
    z-index: -5;
  }

  &.active {
    background: $primary;

    &::after {
      background: $primary;
    }
  }

  .label {
    color: $primary;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 900;
    opacity: 0.6;
    transition: 200ms;

    &.active {
      color: white;
      opacity: 1;
    }
  }
}
</style>
